import _objectSpread from "D:/\u4E91\u76D8/SynologyDrive/Synology Drive/\u6587\u4EF6/\u5BA2\u6237\u8C03\u67E5\u8868/customweb/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapActions } from "vuex";
import http from '../../utils/http';
import { ElLoading } from 'element-plus';
export default {
  data: function data() {
    return {
      loading: true,
      url: {
        loginid: ''
      }
    };
  },
  created: function created() {
    this.fo();
  },
  methods: _objectSpread({
    fo: function fo() {
      var _this = this;

      var loadings = ElLoading.service({
        lock: true,
        text: '加载中请稍后...'
      });
      var urs = '';

      if (process.env.NODE_ENV === 'development') {
        console.log('线下');
        urs = 'http//192.264.36.24name=znM%2B8MXfgiwrLOtX0dB3FQ%3D%3D';
      } else {
        console.log('线上');
        urs = location.href;
        console.log(urs, '线上地址');
      }

      var arrtry = urs.substring(urs.indexOf('=') + 1);
      var sun = decodeURIComponent(arrtry);
      this.url.loginid = sun; // return

      http.post("/oa/login", this.url).then(function (res) {
        console.log(res, '登录数据');
        var _res$data = res.data,
            code = _res$data.code,
            data = _res$data.data,
            accessToken = _res$data.accessToken;

        if (200 == code) {
          loadings.close();

          _this.authority(data);

          sessionStorage.setItem('token', accessToken.token);

          _this.$router.push({
            path: '/gscpds'
          });
        }
      });
    }
  }, mapActions(['authority']))
};